import { Box, Grid, List, Typography, styled } from "@mui/material";

import AdvanceTradeAvailableSkeleton from "components/Skeletons/AdvanceTradeAvailable.Skeleton";
import CoinItem from "./CoinItem";
import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WalletList() {
  const spotWalletList = useSelector(
    (state) => state.wallet.spotWalletList?.data
  );
  const marginWalletList = useSelector(
    (state) => state.wallet.marginWalletList?.data
  );

  const [searchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || WALLET_TYPE.spot;
  const valueBalance = +searchParams.get("valueBalance") || 0;

  const dataToShow = useMemo(() => {
    if (walletTypeId === WALLET_TYPE.spot) return spotWalletList;
    else return marginWalletList;
  }, [walletTypeId, spotWalletList, marginWalletList]);

  return (
    <Grid item xs={12}>
      {dataToShow ? (
        <>
          <BoxHeader>
            <Typography variant="subtitle1" color="text.secondary">
              Symbol
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              AVL
            </Typography>
          </BoxHeader>

          <List sx={{ padding: 0 }} aria-labelledby="nested-list-subheader">
            {dataToShow?.map((coin, index) => (
              <CoinItem key={index} coin={coin} valueBalance={valueBalance} />
            ))}
          </List>
        </>
      ) : (
        <AdvanceTradeAvailableSkeleton />
      )}
    </Grid>
  );
}

const BoxHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderTopRightRadius: "8px",
  borderTopLeftRadius: "8px",
  background: theme.palette.background.primaryGradient,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export default WalletList;
